function detectFileType(byteArray) {
  // Check if the byteArray is valid
  if (!byteArray || byteArray.length < 4) {
    return 'pdf'
  }

  // Convert the first few bytes to a hex string
  const magicNumber = byteArray
    .slice(0, 4)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase()

  // Check for PDF (%PDF)
  if (magicNumber.startsWith('25504446')) {
    // "%PDF" in ASCII
    return 'pdf'
  }

  // Check for JPG (FF D8 FF)
  if (byteArray[0] === 0xff && byteArray[1] === 0xd8 && byteArray[2] === 0xff) {
    return 'png'
  }

  // Check for PNG (89 50 4E 47)
  if (magicNumber === '89504E47' || magicNumber === '8950047') {
    // PNG signature
    return 'png'
  }

  return 'pdf'
}

function base64ToByteArray(base64String) {
  // Decode the Base64 string to a binary string
  const binaryString = atob(base64String)

  // Create a Uint8Array to store the binary data
  const byteArray = new Uint8Array(binaryString.length)

  // Populate the byte array with the binary data
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i)
  }

  return byteArray
}

export { detectFileType, base64ToByteArray }
